import React from 'react';
import { Form, FormGroup, FormControl, Button, Modal, Container, Row, Col } from 'react-bootstrap';
import { CustomDatePicker } from '../../_components';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Navigate } from 'react-router';
import { isAdmin } from '../../utils/roleConstants';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';
import { calculateTableDataMetrics, getTableDataOeeTotal, toTableDataNumber } from '../../utils/tableDataMetrics';
import { tableDataWriteService } from '../../_services/tableDataWrite.service';


class DataManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timestamp: new Date(),
            product: [],
            machine: {},
            modalShow: false,
            newMode: false,
            newModalShow: false,
            body: [],
            actOutput: 0,
            oee: 0,
            productivity: 0,
            executionNumber: 0,
            jobOrder: 0,
            actOutput: 0,
            planOutput: 0,
            engReject: 0,
            prdReject: 0,
            machineDown: 0,
            machineEquipment: 0,
            mouldBreakdown: 0,
            jigFixture: 0,
            engineeringBuild: 0,
            machineSupportDoc: 0,
            manpower: 0,
            facility: 0,
            materialDelay: 0,
            materialNotAvailable: 0,
            unplanBriefing: 0,
            qcBuyoff: 0,
            oeeAvailable: false,
            oeeError: '',
            isLoading: false,
            isWriting: false,
        };
        this.previewTimer = null;
        this.previewRequest = 0;
        this.writeInFlight = false;
        this.columns = [
            {
                name: 'Timestamp',
                selector: row => row.timestamp,
            },
            {
                name: 'Part No',
                selector: row => row.executionNo,
                sortable: true,
            },
            {
                name: 'Job No',
                selector: row => row.jobOrder,
                sortable: true,
            },
            {
                name: 'Employee ID',
                selector: row => row.employeeID,
                sortable: true,
            },
            {
                name: 'Remarks',
                selector: row => row.remark,
                sortable: true,
            },
            {
                name: 'Action',
                cell: (row, rowIndex) => (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap' }}>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            disabled={this.state.isWriting}
                            onClick={() => this.onClickProductSelected(row.id, row, rowIndex)}
                        >
                            Edit
                        </button>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            disabled={this.state.isWriting}
                            onClick={() =>
                                window.confirm("Are you sure you want to delete this data?") &&
                                this.onDeleteProduct(row.id, row, rowIndex)
                            }
                        >
                            Delete
                        </button>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                width: '180px',
            }]
    }

    componentWillMount() {

        this.setState({
            machines: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getAllMachines?active=all&company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    // login successful if there's a user in the response
                    if (machine) {
                        this.setState({ machines: machine });

                    }

                    return machine;
                });
        }

    }

    componentWillUnmount() {
        if (this.previewTimer) clearTimeout(this.previewTimer);
        this.previewRequest += 1;
    }

    buildHtmlTable() {
        this.setState({ isLoading: true });
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ machine: this.state.selectedMachine, date: this.state.selectedDate })
        };

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getMachineByDate?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    // login successful if there's a user in the response
                    let array = [];
                    const products = [];

                    body.map((machine) => {
                        array.push({
                            ...machine,
                            timestamp: (new Date(machine.Timestamp)).toLocaleTimeString(),
                            executionNo: machine.executionNo,
                            employeeID: machine.employeeID,
                            jobOrder: machine.jobOrder,
                            remark: machine.remark
                        })
                    });

                    this.setState({ products: array, body: body, isLoading: false });
                })
                .catch(error => {
                    console.error('Error fetching machine data:', error);
                    this.setState({ products: [], body: [], isLoading: false });
                });

        this.setState({ isLoading: false });
        return Promise.resolve();
    }


    async onClickProductSelected(cell, row, rowIndex) {

        const metrics = calculateTableDataMetrics(row);
        this.setState({
            modalShow: true,
            newMode: false,
            timestamp: row.Timestamp,
            selectedMachine: row.machine,
            executionNumber: row.executionNo,
            cycleTime: toTableDataNumber(row.cycleTime),
            breakTime: toTableDataNumber(row.breakTime),
            jobOrder: row.jobOrder,
            employeeID: row.employeeID,
            actOutput: toTableDataNumber(row.actOutput),
            planOutput: toTableDataNumber(row.planOutput),
            engReject: toTableDataNumber(row.engReject),
            prdReject: toTableDataNumber(row.prdReject),
            machineDown: toTableDataNumber(row.machineDown),
            machineEquipment: toTableDataNumber(row.machineEquipment),
            mouldBreakdown: toTableDataNumber(row.mouldBreakdown),
            jigFixture: toTableDataNumber(row.jigFixture),
            engineeringBuild: toTableDataNumber(row.engineeringBuild),
            machineSupportDoc: toTableDataNumber(row.machineSupportDoc),
            manpower: toTableDataNumber(row.manpower),
            facility: toTableDataNumber(row.facility),
            materialDelay: toTableDataNumber(row.materialDelay),
            materialNotAvailable: toTableDataNumber(row.materialNotAvailable),
            unplanBriefing: toTableDataNumber(row.unplanBriefing),
            qcBuyoff: toTableDataNumber(row.qcBuyoff),
            oee: null,
            oeeAvailable: false,
            oeeError: '',
            productivity: metrics.productivity,
            remark: row.remark,
            id: row.id,
        }, this.requestOeePreview);
    }

    updateMetricField = (field, rawValue) => {
        const value = toTableDataNumber(rawValue);
        this.setState((prevState) => {
            const nextState = { ...prevState, [field]: value };
            return {
                [field]: value,
                productivity: calculateTableDataMetrics(nextState).productivity,
                oee: null,
                oeeAvailable: false,
                oeeError: '',
            };
        }, this.requestOeePreview);
    };

    getOeePreviewDate() {
        const selectedDate = this.state.selectedDate;
        if (typeof selectedDate === 'string' && /^\d{4}-\d{2}-\d{2}/.test(selectedDate)) {
            return selectedDate.slice(0, 10);
        }

        const timestamp = new Date(this.state.timestamp);
        if (Number.isNaN(timestamp.getTime())) return '';
        const pad = (value) => String(value).padStart(2, '0');
        return `${timestamp.getFullYear()}-${pad(timestamp.getMonth() + 1)}-${pad(timestamp.getDate())}`;
    }

    getOeePreviewRow() {
        return {
            machine: this.state.selectedMachine,
            id: this.state.newMode ? undefined : this.state.id,
            cycleTime: this.state.cycleTime,
            breakTime: this.state.breakTime || 0,
            jobOrder: this.state.jobOrder,
            actOutput: this.state.actOutput,
            planOutput: this.state.planOutput,
            engReject: this.state.engReject,
            prdReject: this.state.prdReject,
            machineDown: this.state.machineDown,
            machineEquipment: this.state.machineEquipment,
            mouldBreakdown: this.state.mouldBreakdown,
            jigFixture: this.state.jigFixture,
            engineeringBuild: this.state.engineeringBuild,
            machineSupportDoc: this.state.machineSupportDoc,
            manpower: this.state.manpower,
            facility: this.state.facility,
            materialDelay: this.state.materialDelay,
            materialNotAvailable: this.state.materialNotAvailable,
            unplanBriefing: this.state.unplanBriefing,
            qcBuyoff: this.state.qcBuyoff,
        };
    }

    requestOeePreview = () => {
        if (this.previewTimer) clearTimeout(this.previewTimer);
        const company = (() => {
            try { return JSON.parse(localStorage.getItem('user') || '{}').accountId; } catch (error) { return null; }
        })();
        const machine = String(this.state.selectedMachine || '').trim();
        const date = this.getOeePreviewDate();
        const requestId = ++this.previewRequest;
        this.setState({ oee: null, oeeAvailable: false, oeeError: '' });

        if (!company || !machine || !date) {
            this.setState({ oee: null, oeeAvailable: false, oeeError: 'OEE unavailable. Select a machine and valid date.' });
            return;
        }

        this.previewTimer = setTimeout(() => {
            fetch(`${config.apiUrl}/calculatePepOee`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ company, machine, date, row: this.getOeePreviewRow() }),
            })
                .then((response) => {
                    if (!response.ok) throw new Error(`OEE preview failed with status ${response.status}`);
                    return response.json();
                })
                .then((result) => {
                    if (requestId !== this.previewRequest) return;
                    const value = result && result.oee;
                    if ((typeof value !== 'number' && typeof value !== 'string')
                        || String(value).trim() === '' || !Number.isFinite(Number(value))) {
                        this.setState({ oee: null, oeeAvailable: false, oeeError: 'OEE unavailable. Check planning data for the selected machine, job and date.' });
                        return;
                    }
                    this.setState({ oee: Number(value), oeeAvailable: true, oeeError: '' });
                })
                .catch(() => {
                    if (requestId !== this.previewRequest) return;
                    this.setState({ oee: null, oeeAvailable: false, oeeError: 'OEE unavailable. Retry when your internet connection is back.' });
                });
        }, 300);
    };

    getTableDataPayload(extraValues = {}) {
        return {
            executionNo: this.state.executionNumber,
            employeeID: this.state.employeeID,
            jobOrder: this.state.jobOrder,
            cycleTime: this.state.cycleTime,
            breakTime: this.state.breakTime || 0,
            planOutput: this.state.planOutput,
            actOutput: this.state.actOutput,
            engReject: this.state.engReject,
            prdReject: this.state.prdReject,
            machineDown: this.state.machineDown,
            machineEquipment: this.state.machineEquipment,
            machineSupportDoc: this.state.machineSupportDoc,
            mouldBreakdown: this.state.mouldBreakdown,
            engineeringBuild: this.state.engineeringBuild,
            jigFixture: this.state.jigFixture,
            manpower: this.state.manpower,
            materialDelay: this.state.materialDelay,
            materialNotAvailable: this.state.materialNotAvailable,
            facility: this.state.facility,
            unplanBriefing: this.state.unplanBriefing,
            qcBuyoff: this.state.qcBuyoff,
            oee: this.state.oeeAvailable ? this.state.oee : null,
            productivity: this.state.productivity,
            remark: this.state.remark,
            ...extraValues,
        };
    }

    showTableDataWriteError(error) {
        if (error && error.retryable) {
            window.alert(`Record was not saved. OEE is unavailable. Retry when your internet connection is back. ${error.message || ''}`.trim());
            return;
        }

        window.alert((error && error.message) || 'Unable to save OEE data');
    }

    runTableDataWrite(request, onSuccess) {
        if (this.writeInFlight) return Promise.resolve();

        this.writeInFlight = true;
        this.setState({ isWriting: true });
        return request()
            .then(onSuccess)
            .catch((error) => this.showTableDataWriteError(error))
            .finally(() => {
                this.writeInFlight = false;
                this.setState({ isWriting: false });
            });
    }

    onDeleteProduct(cell, row, rowIndex) {
        return this.runTableDataWrite(
            () => tableDataWriteService.remove({ id: row.id }),
            () => {
                window.alert('Deleted Successfully.');
                return this.buildHtmlTable();
            });
    }



    isSelectedMachineInactive() {
        return this.state.machines.some(machine =>
            machine.machine === this.state.selectedMachine && machine.active === false
        );
    }

    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!isAdmin(user)) {
            return <Navigate to='/' />
        }
        let { modalShow, newMode, products, timestamp, cycleTime, oee, oeeAvailable, oeeError, productivity, executionNumber, jobOrder, employeeID, actOutput, planOutput, engReject, prdReject, machineDown, machineEquipment, mouldBreakdown, jigFixture, engineeringBuild, machineSupportDoc, manpower, facility, materialDelay, materialNotAvailable, unplanBriefing, qcBuyoff, remark } = this.state;
        let handleClose = () => this.setState({ modalShow: false });
        const selectedMachineInactive = this.isSelectedMachineInactive();
        let handleSave = () => {
            if (!oeeAvailable) {
                window.alert(oeeError || 'OEE unavailable. Retry when your internet connection is back.');
                return;
            }
            if (!window.confirm("Are you sure you update this data?")) return;

            return this.runTableDataWrite(
                () => tableDataWriteService.update(this.getTableDataPayload({
                    id: this.state.id,
                })),
                () => {
                    window.alert('Update Successfully.');
                    this.setState({ modalShow: false });
                    return this.buildHtmlTable();
                });
        }

        let handleCreate = () => {
            if (this.isSelectedMachineInactive()) return;

            if (!oeeAvailable) {
                window.alert(oeeError || 'OEE unavailable. Retry when your internet connection is back.');
                return;
            }
            return this.runTableDataWrite(
                () => tableDataWriteService.create(this.getTableDataPayload({
                    machine: this.state.selectedMachine,
                    category: this.state.selectedCategory,
                    company: JSON.parse(localStorage.getItem('user')).accountId,
                    created_by: JSON.parse(localStorage.getItem('user')).id,
                    Timestamp: new Date(this.state.selectedDate + ' ' + moment(this.state.timestamp).format('HH:mm'))
                })),
                () => {
                    window.alert('New data created successfully.');
                    this.setState({ modalShow: false, newMode: false });
                    return this.buildHtmlTable();
                });
        }

        let isTally = () => {
            return toTableDataNumber(planOutput) == getTableDataOeeTotal(this.state);
        }

        return (
            <div class="container">
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Select a machine:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedMachineId} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                            this.setState({
                                                selectedMachine: e.target.value.split(';')[0], selectedCategory: e.target.value.split(';')[1]
                                            }, this.requestOeePreview)
                                    } else {
                                        delete this.state.selectedMachine;
                                    }
                                }}>
                                <option value="select">select</option>
                                {
                                    this.state.machines.map((machine) => {
                                        return <option key={machine.id} value={machine.machine + ';' + machine.category}>{machine.machine}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <CustomDatePicker
                            label="Date"
                            controlId="formInlineDate"
                            value={this.state.selectedDate}
                            onChange={(value) => this.setState({ selectedDate: value }, this.requestOeePreview)}
                        />{' '}
                        <Button
                            bsStyle="primary"
                            // disabled={isLoading}
                            // onClick={!isLoading ? this.handleClick : null}
                            onClick={e => this.buildHtmlTable()}>Show</Button>
                        {this.state.selectedMachine && this.state.selectedDate && !selectedMachineInactive && (<Button
                            style={{ right: 0, position: 'absolute' }}
                            bsStyle="danger"
                            visi
                            onClick={e => { 
                                this.setState({ 
                                    modalShow: true, 
                                    newMode: true,
                                    timestamp: new Date(),
                                    executionNumber: '',
                                    cycleTime: '',
                                    jobOrder: '',
                                    breakTime: 0,
                                    employeeID: '',
                                    actOutput: 0,
                                    planOutput: 0,
                                    engReject: 0,
                                    prdReject: 0,
                                    machineDown: 0,
                                    machineEquipment: 0,
                                    mouldBreakdown: 0,
                                    jigFixture: 0,
                                    engineeringBuild: 0,
                                    machineSupportDoc: 0,
                                    manpower: 0,
                                    facility: 0,
                                    materialDelay: 0,
                                    materialNotAvailable: 0,
                                    unplanBriefing: 0,
                                    qcBuyoff: 0,
                                    oee: null,
                                    oeeAvailable: false,
                                    oeeError: '',
                                    productivity: 0,
                                    remark: ''
                                }, this.requestOeePreview);
                            }}>New</Button>)}

                    </Form>
                </div>
                <DataTable
                    columns={this.columns}
                    data={products}
                    progressPending={this.state.isLoading}
                    progressComponent={<DatacoLoadingIndicator loading={this.state.isLoading} size="compact" label="Loading machine data" />}
                    pagination
                    highlightOnHover
                />
                <Modal size="lg" show={modalShow} onHide={handleClose}
                    aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w">
                    <Modal.Header closeButton>
                        {newMode ? (<Modal.Title>New</Modal.Title>) : (<Modal.Title>Edit</Modal.Title>)}
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form>
                                <FormGroup className="row" as={Row} controlId="formInlineTimestamp" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Timestamp:</Form.Label></Col>
                                    <Col sm={9}> 
                                        <DatePicker
                                            selected={timestamp && timestamp instanceof Date && !isNaN(timestamp) ? timestamp : new Date()}
                                            onChange={(date) => this.setState({ timestamp: date }, this.requestOeePreview)}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={30}           // equivalent to minuteStep="30"
                                            timeCaption="Time"
                                            dateFormat="h:mm aa"         // 12-hour format
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineCycletime" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Cycle Time</Form.Label></Col>
                                    <Col sm={9}><FormControl type="number" step="any" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ cycleTime: ev.target.value }, this.requestOeePreview) }} value={cycleTime} />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineExecutionNo" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ executionNumber: ev.target.value }) }} value={executionNumber} />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineJobrOrder" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Job No</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ jobOrder: ev.target.value }, this.requestOeePreview) }} value={jobOrder} />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineEmployeeID" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Employee ID</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ employeeID: ev.target.value }) }} value={employeeID} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Plan Output</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('planOutput', ev.target.value)} value={planOutput} /></Col>
                                    <Col sm={3}><Form.Label>Actual Output</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('actOutput', ev.target.value)} value={actOutput} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Engineering Reject</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('engReject', ev.target.value)} value={engReject} /></Col>
                                    <Col sm={3}><Form.Label>Production Reject</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('prdReject', ev.target.value)} value={prdReject} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Machine Breakdown</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('machineDown', ev.target.value)} value={machineDown} /></Col>
                                    <Col sm={3}><Form.Label>Tooling Breakdown</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('mouldBreakdown', ev.target.value)} value={mouldBreakdown} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Jig&Fixture</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('jigFixture', ev.target.value)} value={jigFixture} /></Col>
                                    <Col sm={3}><Form.Label>Engineering build</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('engineeringBuild', ev.target.value)} value={engineeringBuild} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Change-over</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('machineSupportDoc', ev.target.value)} value={machineSupportDoc} /></Col>
                                    <Col sm={3}><Form.Label>Machine Equipment</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('machineEquipment', ev.target.value)} value={machineEquipment} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Manpower</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('manpower', ev.target.value)} value={manpower} /></Col>
                                    <Col sm={3}><Form.Label>Facility</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('facility', ev.target.value)} value={facility} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Material Delay</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('materialDelay', ev.target.value)} value={materialDelay} /></Col>
                                    <Col sm={3}><Form.Label>Material Not Available</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('materialNotAvailable', ev.target.value)} value={materialNotAvailable} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Unplan Meeting</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('unplanBriefing', ev.target.value)} value={unplanBriefing} /></Col>
                                    <Col sm={3}><Form.Label htmlFor="qcBuyoff">O6 QC Buyoff</Form.Label></Col>
                                    <Col sm={3}><FormControl id="qcBuyoff" type="number" onFocus={ev => ev.target.select()} onChange={ev => this.updateMetricField('qcBuyoff', ev.target.value)} value={qcBuyoff} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>OEE%</Form.Label></Col>
                                    <Col sm={3}><FormControl plaintext readOnly value={oeeAvailable ? oee : (oeeError || 'OEE unavailable')} /></Col>
                                    <Col sm={3}><Form.Label>Productivity%</Form.Label></Col>
                                    <Col sm={3}><FormControl plaintext readOnly value={productivity} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Remark</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ remark: ev.target.value }) }} value={remark} /></Col>
                                </FormGroup>
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        {(executionNumber != 0 && planOutput != 0 && actOutput != 0 && isTally() && newMode) && (<Button variant="primary" onClick={handleCreate} disabled={this.state.isWriting || selectedMachineInactive}>
                            Create
                        </Button>)}

                        {!newMode && (<Button variant="primary" onClick={handleSave} disabled={this.state.isWriting}>
                            Save Changes
                        </Button>)}
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

export { DataManagement };
